import { useEffect, useMemo } from 'react'

import { DSAlert, DSCircularLoading, DSPagination } from '@vr/ds-react'

import { DeliveryUnits } from '@/compositions/delivery-units'
import { useDeliveryContext } from '@/contexts/delivery.context'

const PAGE_SIZE = 10

export const DeliveryList = () => {
  const {
    tableData,
    isLoading,
    results,
    limit,
    setPage,
    handleLimitChange
  } = useDeliveryContext()

  useEffect(() => {
    handleLimitChange(PAGE_SIZE)
  }, [])

  const mappedData = useMemo(() => {
    return tableData.map(item => {
      return {
        ...item,
        operadora: item.nome
      }
    })
  }, [tableData])

  return (
    <>
      {isLoading && <DSCircularLoading isLoading shouldBlur={true} />}

      {!isLoading && mappedData.length === 0 && (
        <DSAlert
          type='info'
          title={'Sem resultados para os filtros selecionados'}
          css={{ marginTop: '$sm16' }}
          hiddenBtnClose
        >
          Tente ajustar os filtros para exibir os resultados desejados
        </DSAlert>
      )}

      {mappedData.map(item => (
        <DeliveryUnits key={item.id} data={item} />
      ))}

      <DSPagination
        total={results}
        maxPerPage={limit}
        handleChange={(newPage: number) => setPage(newPage)}
        nextPreview
        siblingCount={1}
      />
    </>
  )
}
